export var WX_MINI_APP;
(function (WX_MINI_APP) {
    WX_MINI_APP["MT"] = "\u7F8E\u56E2";
    WX_MINI_APP["DP"] = "\u70B9\u8BC4";
    WX_MINI_APP["HOTEL"] = "\u9152\u5E97+";
})(WX_MINI_APP || (WX_MINI_APP = {}));
export const WX_MINI_APP_RAW_ID = {
    [WX_MINI_APP.MT]: 'gh_870576f3c6f9',
    [WX_MINI_APP.DP]: 'gh_bc5b635c05c4',
    [WX_MINI_APP.HOTEL]: 'gh_d5ea568e0053'
};
